import { Box } from "@mui/material";
import { ClockLoader } from "react-spinners";
import { Properties } from "csstype";

import { TestTimerVariables } from "../../types/test-types";

const MiddlePauseSlide = (props: { variables: TestTimerVariables }) => {
  return (
    <Box sx={styles.main}>
      <ClockLoader
        color="#385723"
        cssOverride={buttonStyle}
        loading={!props.variables.paused}
        size={250}
        speedMultiplier={0.5}
      />
    </Box>
  );
};

const styles = {
  main: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
  },
};

const buttonStyle: Properties<string | number> = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};

export default MiddlePauseSlide;
